module.exports = __webpack_public_path__ + "6b71b9f232b9e79a7df156a56947bde3.pdf";